function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1404 -6858)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 6583",
    width: 40,
    height: 40,
    rx: 20,
    transform: "translate(1404 6858)",
    style: {
      fill: "#133b62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "linkedin",
    d: "M0 7.22a2.079 2.079 0 0 1 .676-1.593A2.479 2.479 0 0 1 2.432 5a2.4 2.4 0 0 1 1.718.618 2.177 2.177 0 0 1 .676 1.66 2.033 2.033 0 0 1-.656 1.544 2.483 2.483 0 0 1-1.776.637h-.019a2.363 2.363 0 0 1-1.719-.637A2.14 2.14 0 0 1 0 7.22zm.251 16.892v-12.9h4.286v12.9zm6.66 0H11.2v-7.2a2.513 2.513 0 0 1 .975-2.153 2.1 2.1 0 0 1 1.38-.454q2.162 0 2.162 2.915v6.892H20v-7.394a6.213 6.213 0 0 0-1.351-4.334 4.61 4.61 0 0 0-3.571-1.477A4.381 4.381 0 0 0 11.2 13.05v.039h-.019l.019-.039v-1.834H6.911q.039.618.039 3.842t-.039 9.054z",
    transform: "translate(1414 6863)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.d93ebb4e4af358a8dbe2364523b9e146.svg";
export { ForwardRef as ReactComponent };